import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ConteudosComponent } from './conteudos/conteudos.component';
import { PerdaDocumentosComponent } from './conteudos/perda-documentos/perda-documentos.component';
import { ExperienciaClienteComponent } from './conteudos/experiencia-cliente/experiencia-cliente.component';
import { NeuralBankComponent } from './neural-bank/neural-bank.component';
import { SolucaoComponent } from './solucao/solucao.component';
import { GlassCubeComponent } from './glass-cube/glass-cube.component';
import { SistemaMockupComponent } from './home/sistema-mockup/sistema-mockup.component';
import { PoliticaPrivacidadeComponent } from './politica-privacidade/politica-privacidade.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomeComponent,
    NavbarComponent,
    ConteudosComponent,
    PerdaDocumentosComponent,
    ExperienciaClienteComponent,
    NeuralBankComponent,
    SolucaoComponent,
    GlassCubeComponent,
    SistemaMockupComponent,
    PoliticaPrivacidadeComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
